import {
  AfterViewChecked,
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  HostListener,
  OnInit,
  ViewChild
} from '@angular/core';
import {UserService} from '../../core/services/user.service';
import {Router} from '@angular/router';
import {HttpService} from '../../core';

/**
 * @class AdminLayoutComponent
 * @memberOf ThemeModule
 * @description The component is used to combine left side navigation bar component and top header
 */
@Component({
  selector: 'app-admin-layout',
  templateUrl: './admin-layout.component.html',
  styleUrls: ['./admin-layout.component.scss']
})

export class AdminLayoutComponent implements OnInit, AfterViewInit, AfterViewChecked {

  @ViewChild('sidenav') sidenav;
  highestRole: any;
  email: any;
  company: any;
  user: any;

  screenWidth: any;

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.screenWidth = window.innerWidth;
    if (this.screenWidth < 960) {
      this.sidenav.close();
    } else {
      this.sidenav.open();
    }
  }

  constructor(private userService: UserService, private router: Router, private httpService: HttpService, private cdf: ChangeDetectorRef) {
  }

  ngOnInit(): void {
    this.userService.currentUser.subscribe((r: any) => {
      console.log(r);
      this.highestRole = r.roles[0];
      this.email = r.email;
      this.user = r;
      this.httpService.getInfo().subscribe((res1: any) => {
        if (res1.data?.company?.id) {
          this.httpService.getCompanyById(res1.data.company.id).subscribe((res: any) => {
            this.company = res.data;
          });
        } else {
          this.company = null;
        }
      });
      // this.httpService.getCompanyById(r.company.id).subscribe((res: any) => {
      //   this.company = res.data;
      // });
    });
  }

  ngAfterViewInit(): void {
    this.screenWidth = window.innerWidth;
    if (this.screenWidth < 960) {
      this.sidenav.close();
    } else {
      this.sidenav.open();
    }
  }

  ngAfterViewChecked() {
    this.cdf.detectChanges();
  }

  getData(event) {
    this.sidenav.toggle();
  }

}
